import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/68b89414438ec5500f122273_vertical-yellow.svg"
              alt="American Guard Services"
              className="h-16 mb-4"
            />
            <p className="text-dark-300 text-sm mb-4">
              Professional security services you can trust since 1997
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/americanguardservicesinc/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-dark-700 rounded-full hover:bg-primary-500 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/americanguardservicesinc/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-dark-700 rounded-full hover:bg-primary-500 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/americanguard-services-inc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-dark-700 rounded-full hover:bg-primary-500 transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Armed Security Officers
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Unarmed Security Officers
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Event Security
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Patrol & Mobile Surveillance
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Construction Site Security
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Loss Prevention Security
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Industries Served
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Locations
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-primary-400 mt-1 mr-3"></i>
                <a href="tel:1-800-662-7372" className="text-dark-300 hover:text-primary-400 text-sm transition-colors">
                  1-800-662-7372
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-primary-400 mt-1 mr-3"></i>
                <a
                  href="mailto:marketing@americanguardservices.com"
                  className="text-dark-300 hover:text-primary-400 text-sm transition-colors"
                >
                  marketing@americanguardservices.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-primary-400 mt-1 mr-3"></i>
                <span className="text-dark-300 text-sm">
                  1125 W 190th St.<br />Los Angeles, CA 90248
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-dark-700 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-dark-400 text-sm mb-4 md:mb-0">
            © 2025 American Guard Services. All rights reserved.
          </p>
          <div className="flex items-center space-x-4">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-dark-400 hover:text-primary-400 text-sm transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;